var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg9Squares(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 5.71429,
    height: 5.71429,
    rx: 1,
    fill: "#080134"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 7.14282,
    width: 5.71429,
    height: 5.71429,
    rx: 1,
    fill: "#080134"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 14.2856,
    width: 5.71429,
    height: 5.71429,
    rx: 1,
    fill: "#080134"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.64288,
    width: 5.71429,
    height: 5.71429,
    rx: 1,
    fill: "#080134"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.64288,
    y: 7.14282,
    width: 5.71429,
    height: 5.71429,
    rx: 1,
    fill: "#080134"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7.64288,
    y: 14.2856,
    width: 5.71429,
    height: 5.71429,
    rx: 1,
    fill: "#080134"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7857,
    width: 5.71429,
    height: 5.71429,
    rx: 1,
    fill: "#080134"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7857,
    y: 7.14282,
    width: 5.71429,
    height: 5.71429,
    rx: 1,
    fill: "#080134"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7857,
    y: 14.2856,
    width: 5.71429,
    height: 5.71429,
    rx: 1,
    fill: "#080134"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg9Squares);
export default __webpack_public_path__ + "static/media/9-squares.fd3c1902.svg";
export { ForwardRef as ReactComponent };